module.exports = __webpack_public_path__ + "static/media/AR_logo.8393d70d.svg";